import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14df1d58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-background": "rgba(0, 0, 0, 0.5)" }
const _hoisted_2 = { style: {"width":"80%","margin-left":"350px","text-align":"center"} }
const _hoisted_3 = { style: {"float":"left"} }
const _hoisted_4 = {
  key: 0,
  style: {"float":"left","margin-left":"15px"}
}
const _hoisted_5 = {
  key: 1,
  class: "summary-time"
}
const _hoisted_6 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_7 = { style: {"width":"100%","word-break":"break-all","text-align":"center","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  style: {"cursor":"pointer","width":"100% !important","word-break":"break-all","text-align":"center","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_10 = {
  key: 1,
  style: {"width":"100% !important","word-break":"break-all","text-align":"center","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_11 = {
  key: 1,
  style: {"width":"100% !important","word-break":"break-all","text-align":"center","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  style: {"color":"#409EFF","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_15 = {
  key: 1,
  style: {"color":"#fe995b"}
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0px"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "计划入货时间")
], -1))
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  style: {"color":"#409EFF","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_22 = {
  key: 1,
  style: {"color":"#fe995b"}
}
const _hoisted_23 = {
  key: 1,
  style: {"width":"100% !important","word-break":"break-all","text-align":"center","height":"40px","line-height":"40px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_24 = { style: {"margin":"0px"} }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "入库货量", -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  style: {"color":"#409EFF","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_29 = {
  key: 1,
  style: {"color":"#fe995b"}
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { style: {"text-align":"center"} }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { style: {"margin":"0px"} }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全部入库日期", -1))
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  style: {"color":"#409EFF","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_38 = {
  key: 1,
  style: {"color":"#fe995b"}
}
const _hoisted_39 = {
  key: 1,
  style: {"width":"100% !important","word-break":"break-all","text-align":"center","height":"40px","line-height":"40px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_40 = { style: {"margin":"0px"} }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "出库货量", -1))
const _hoisted_42 = { key: 0 }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 0,
  style: {"color":"#409EFF","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_45 = {
  key: 1,
  style: {"color":"#fe995b"}
}
const _hoisted_46 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { style: {"margin":"0px"} }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全部出库日期", -1))
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 0,
  style: {"color":"#409EFF","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_53 = {
  key: 1,
  style: {"color":"#fe995b"}
}
const _hoisted_54 = {
  key: 1,
  style: {"width":"100% !important","word-break":"break-all","text-align":"center","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { style: {"margin":"0px"} }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "供应商", -1))
const _hoisted_58 = ["onClick"]
const _hoisted_59 = {
  key: 0,
  style: {"color":"#409EFF","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_60 = {
  key: 1,
  style: {"color":"#fe995b"}
}
const _hoisted_61 = {
  key: 1,
  style: {"width":"100% !important","word-break":"break-all","text-align":"center","height":"40px","line-height":"40px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_62 = ["onClick"]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { style: {"width":"100% !important","text-align":"center"} }
const _hoisted_65 = {
  key: 0,
  style: {"color":"red","font-weight":"900"},
  title: "计划货量/入库货量/出库货量的合计件数不一致"
}
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { style: {"font-size":"13px","color":"#fe995b","font-weight":"900","padding-top":"15px"} }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, "历史记录", -1))
const _hoisted_69 = { style: {"float":"right"} }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { style: {"font-size":"13px"} }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { style: {"float":"left"} }
const _hoisted_74 = { style: {"font-weight":"900"} }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = {
  key: 0,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_77 = {
  key: 1,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_79 = {
  key: 0,
  style: {"text-indent":"20px","line-height":"28px"}
}
const _hoisted_80 = {
  key: 0,
  style: {"clear":"both"}
}
const _hoisted_81 = {
  key: 0,
  style: {"float":"left"}
}
const _hoisted_82 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_83 = {
  key: 0,
  style: {}
}
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { style: {"font-weight":"900"} }
const _hoisted_87 = { key: 1 }
const _hoisted_88 = { style: {"font-weight":"900"} }
const _hoisted_89 = { key: 2 }
const _hoisted_90 = { style: {"font-weight":"900"} }
const _hoisted_91 = { key: 3 }
const _hoisted_92 = { style: {} }
const _hoisted_93 = { key: 1 }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { style: {"font-weight":"900"} }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = { style: {"font-weight":"900"} }
const _hoisted_100 = { key: 2 }
const _hoisted_101 = { style: {"font-weight":"900"} }
const _hoisted_102 = { key: 3 }
const _hoisted_103 = { style: {} }
const _hoisted_104 = { key: 1 }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_106 = {
  key: 1,
  style: {"clear":"both"}
}
const _hoisted_107 = { key: 0 }
const _hoisted_108 = { key: 0 }
const _hoisted_109 = { style: {"font-weight":"900"} }
const _hoisted_110 = { key: 1 }
const _hoisted_111 = { style: {"font-weight":"900"} }
const _hoisted_112 = { key: 2 }
const _hoisted_113 = { style: {"font-weight":"900"} }
const _hoisted_114 = { key: 3 }
const _hoisted_115 = { style: {} }
const _hoisted_116 = { key: 1 }
const _hoisted_117 = {
  key: 0,
  style: {"float":"left"}
}
const _hoisted_118 = {
  key: 1,
  style: {"float":"left"}
}
const _hoisted_119 = { style: {"float":"left","text-indent":"20px"} }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = { style: {"font-weight":"900"} }
const _hoisted_122 = { key: 1 }
const _hoisted_123 = { style: {"font-weight":"900"} }
const _hoisted_124 = { key: 2 }
const _hoisted_125 = { style: {"font-weight":"900"} }
const _hoisted_126 = { key: 3 }
const _hoisted_127 = { style: {} }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_130 = {
  key: 1,
  style: {"height":"40px","line-height":"40px","text-align":"center","font-size":"14px","color":"#999"}
}
const _hoisted_131 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_132 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_133 = { style: {"clear":"both","height":"25px","margin-top":"20px"} }
const _hoisted_134 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_135 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_136 = { style: {"clear":"both","height":"25px","margin-top":"20px"} }
const _hoisted_137 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_138 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_139 = { style: {"clear":"both","height":"25px","margin-top":"20px"} }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 附件 ", -1))
const _hoisted_141 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_142 = { key: 1 }
const _hoisted_143 = { style: {"margin-left":"3px"} }
const _hoisted_144 = { key: 0 }
const _hoisted_145 = { key: 1 }
const _hoisted_146 = { style: {"margin-left":"3px"} }
const _hoisted_147 = { key: 0 }
const _hoisted_148 = { key: 1 }
const _hoisted_149 = { key: 0 }
const _hoisted_150 = { style: {"font-size":"14px","height":"24px"} }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-document" }, null, -1))
const _hoisted_152 = { style: {"font-size":"12px","cursor":"pointer","color":"#409eff"} }
const _hoisted_153 = ["href"]
const _hoisted_154 = { key: 1 }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "暂无数据", -1))
const _hoisted_156 = [
  _hoisted_155
]
const _hoisted_157 = { style: {"clear":"both","height":"25px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_order_summary_time = _resolveComponent("order-summary-time")!
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_miezz_wharf_plan = _resolveComponent("miezz-wharf-plan")!
  const _component_miezz_wharf_in_stock = _resolveComponent("miezz-wharf-in-stock")!
  const _component_miezz_wharf_out_stock = _resolveComponent("miezz-wharf-out-stock")!
  const _component_miezz_supplier = _resolveComponent("miezz-supplier")!
  const _component_miezz_wharf_warehousing = _resolveComponent("miezz-wharf-warehousing")!
  const _component_miezz_wharf_box_sticker = _resolveComponent("miezz-wharf-box-sticker")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Document = _resolveComponent("Document")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_miezz_menu_tab, {
      modelValue: _ctx.menuTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
    }, {
      center: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_order_summary_time, { id: _ctx._orderId }, null, 8, ["id"])
          ]),
          (_ctx.wharfType==0 && _ctx.id!=null && _ctx.id!=undefined && _ctx.id!='' && (_ctx.orderId==null || _ctx.orderId==undefined || _ctx.orderId==''))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "入库合计计费：" + _toDisplayString(_ctx.list.Data.ChargeWeightString), 1))
            : _createCommentVNode("", true),
          (_ctx.type == _ctx.EnumOrderServiceType.DestinationPort)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.list.Data.IsQuantity == false)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "注意：装货港计划货量/入库货量/出库货量的合计件数不一致"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.list.Data.Items,
          ref: "customsTable",
          stripe: "",
          style: {"width":"100%"},
          "header-cell-style": { 'text-align': 'center' },
          "cell-style": _ctx.cellClassName,
          "row-style": _ctx.rowStyle,
          border: "",
          "max-height": "500"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "Code",
              label: "编号",
              "show-overflow-tooltip": true
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.isString(scope.row.Code)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "委托人",
              "show-overflow-tooltip": true
            }, {
              default: _withCtx((scope) => [
                (scope.row.ClientCompany!=null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_ctx.OrderManagement_Pool_Summary_PortOfDepartureCustomsAffairs_Edit==true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.isString(scope.row.ClientCompany.NameZh)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.isString(scope.row.ClientCompany.NameZh)), 1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, " 暂无数据 "))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "SumQuantity",
              label: "计划货量",
              "show-overflow-tooltip": true
            }, {
              default: _withCtx((scope) => [
                (_ctx.isEdit==true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.onPlan(scope.row)),
                        style: {"cursor":"pointer","text-align":"center"}
                      }, [
                        (scope.row.SumQuantity)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(scope.row.SumQuantity + scope.row.ChargeUnit) + "/" + _toDisplayString(scope.row.SumGrossWeight) + "KGS/" + _toDisplayString(scope.row.SumVolume) + "CBM ", 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15, " 暂无数据 "))
                      ], 8, _hoisted_13)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (scope.row.SumQuantity!=undefined)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.onPlan(scope.row)),
                            style: {"cursor":"pointer","width":"100% !important","word-break":"break-all","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
                          }, _toDisplayString(scope.row.SumQuantity + scope.row.ChargeUnit) + "/" + _toDisplayString(scope.row.SumGrossWeight) + "KGS/" + _toDisplayString(scope.row.SumVolume) + "CBM ", 9, _hoisted_17))
                        : (_openBlock(), _createElementBlock("span", _hoisted_18, "暂无数据"))
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "PlanInStockTimeString",
              label: "计划入货时间",
              "show-overflow-tooltip": true
            }, {
              header: _withCtx(() => [
                _hoisted_19
              ]),
              default: _withCtx((scope) => [
                (_ctx.isEdit==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.onPlanInStockTime(scope.row)),
                      style: {"cursor":"pointer","text-align":"center"}
                    }, [
                      (scope.row.PlanInStockTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(scope.row.PlanInStockTimeString), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22, " 暂无数据 "))
                    ], 8, _hoisted_20))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.isString(scope.row.PlanInStockTimeString)), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "SumQuantityInStock",
              label: "入库货量",
              "show-overflow-tooltip": true
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  (_ctx.isEdit==true && _ctx.orderId!=null && _ctx.orderId!=undefined && _ctx.orderId!='')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        title: "批量操作",
                        style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onBatchInStock()))
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Edit)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              default: _withCtx((scope) => [
                (_ctx.isEdit==true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.onInStock(scope.row)),
                        style: {"cursor":"pointer","text-align":"center"}
                      }, [
                        (scope.row.SumQuantityInStock)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(scope.row.SumQuantityInStock + scope.row.ChargeUnitInStock) + "/" + _toDisplayString(scope.row.SumGrossWeightInStock) + "KGS/" + _toDisplayString(scope.row.SumVolumeInStock) + "CBM ", 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_29, " 暂无数据 "))
                      ], 8, _hoisted_27)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        (scope.row.SumQuantityInStock!=undefined)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.onInStock(scope.row)),
                              style: {"cursor":"pointer","width":"100% !important","word-break":"break-all","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
                            }, _toDisplayString(scope.row.SumQuantityInStock + scope.row.ChargeUnitInStock) + "/" + _toDisplayString(scope.row.SumGrossWeightInStock) + "KGS/" + _toDisplayString(scope.row.SumVolumeInStock) + "CBM ", 9, _hoisted_32))
                          : (_openBlock(), _createElementBlock("span", _hoisted_33, "暂无数据"))
                      ])
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "InStockTimeString",
              label: "全部入库日期",
              "show-overflow-tooltip": true
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  (_ctx.isEdit==true && _ctx.orderId!=null && _ctx.orderId!=undefined && _ctx.orderId!='')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        title: "批量操作",
                        style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onBatchInStockTime()))
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Edit)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              default: _withCtx((scope) => [
                (_ctx.isEdit==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.onInStockTime(scope.row)),
                      style: {"cursor":"pointer","text-align":"center"}
                    }, [
                      (scope.row.InStockTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(scope.row.InStockTimeString), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_38, " 暂无数据 "))
                    ], 8, _hoisted_36))
                  : (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.isString(scope.row.InStockTimeString)), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "SumQuantityOutStock",
              label: "出库货量",
              "show-overflow-tooltip": true
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  (_ctx.isEdit==true && _ctx.orderId!=null && _ctx.orderId!=undefined && _ctx.orderId!='')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        title: "批量操作",
                        style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onBatchOutStock()))
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Edit)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              default: _withCtx((scope) => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: scope.row.IsShiftout?8:0,
                      style: {"color":"red","font-weight":"600","line-height":"40px"}
                    }, {
                      default: _withCtx(() => [
                        (scope.row.IsShiftout)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, "移库"))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["span"]),
                    _createVNode(_component_el_col, {
                      span: scope.row.IsShiftout?16:24
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isEdit==true)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.onOutStock(scope.row)),
                              style: {"cursor":"pointer","text-align":"center"}
                            }, [
                              (scope.row.SumQuantityOutStock)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(scope.row.SumQuantityOutStock + scope.row.ChargeUnitOutStock) + "/" + _toDisplayString(scope.row.SumGrossWeightOutStock) + "KGS/" + _toDisplayString(scope.row.SumVolumeOutStock) + "CBM ", 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_45, " 暂无数据 "))
                            ], 8, _hoisted_43))
                          : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              (scope.row.SumQuantityOutStock)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.onOutStock(scope.row)),
                                    style: {"cursor":"pointer","width":"100% !important","word-break":"break-all","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
                                  }, _toDisplayString(scope.row.SumQuantityOutStock + scope.row.ChargeUnitOutStock) + "/" + _toDisplayString(scope.row.SumGrossWeightOutStock) + "KGS/" + _toDisplayString(scope.row.SumVolumeOutStock) + "CBM ", 9, _hoisted_47))
                                : (_openBlock(), _createElementBlock("div", _hoisted_48, "暂无数据"))
                            ]))
                      ]),
                      _: 2
                    }, 1032, ["span"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "OutStockTimeString",
              label: "全部出库日期",
              "show-overflow-tooltip": true
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  (_ctx.isEdit==true && _ctx.orderId!=null && _ctx.orderId!=undefined && _ctx.orderId!='')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        title: "批量操作",
                        style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onBatchOutStockTime()))
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Edit)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              default: _withCtx((scope) => [
                (_ctx.isEdit==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.onOutStockTime(scope.row)),
                      style: {"cursor":"pointer","text-align":"center"}
                    }, [
                      (scope.row.OutStockTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(scope.row.OutStockTimeString), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_53, " 暂无数据 "))
                    ], 8, _hoisted_51))
                  : (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_ctx.isString(scope.row.OutStockTimeString)), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "ClientCompany",
              label: "货物清单",
              width: "90px",
              "show-overflow-tooltip": true
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.onGoods(scope.row))
                }, [
                  _createVNode(_component_miezz_text_ellipsis, {
                    text: scope.row.IsGoods==true ? '查看详情' : '暂无数据',
                    style: _normalizeStyle((scope.row.IsGoods == true) ? 'color: #409EFF' : 'color: #fe995b')
                  }, null, 8, ["text", "style"])
                ], 8, _hoisted_55)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "Supplier",
              label: "供应商",
              "show-overflow-tooltip": true
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  (_ctx.logier.DisabledReadSupplier!=true && _ctx.isEdit==true && _ctx.orderId!=null && _ctx.orderId!=undefined && _ctx.orderId!='')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        title: "批量操作",
                        style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onBatchSupplier()))
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Edit)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              default: _withCtx((scope) => [
                (_ctx.logier.DisabledReadSupplier!=true && _ctx.isEdit==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.onSupplier(scope.row)),
                      style: {"cursor":"pointer","text-align":"center"}
                    }, [
                      (scope.row.Supplier)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(scope.row.Supplier), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_60, " 暂无数据 "))
                    ], 8, _hoisted_58))
                  : (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.isString(scope.row.Supplier)), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "AnnexString",
              label: "附件",
              width: "90px",
              "show-overflow-tooltip": true
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.onAnnex(scope.row))
                }, [
                  _createVNode(_component_miezz_text_ellipsis, {
                    text: scope.row.IsEditWarehousing==true ? '查看详情' : '暂无数据',
                    style: _normalizeStyle((scope.row.IsEditWarehousing == true) ? 'color: #409EFF' : 'color: #fe995b')
                  }, null, 8, ["text", "style"])
                ], 8, _hoisted_62)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "Code",
              label: "进程",
              width: "90px",
              "show-overflow-tooltip": true
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.onProcess(scope.row)),
                  style: {"cursor":"pointer","color":"#409EFF","width":"100%","word-break":"break-all","text-align":"center","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
                }, " 查看详情 ", 8, _hoisted_63)
              ]),
              _: 1
            }),
            (_ctx.isDelete==true)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  prop: "Executor",
                  label: "操作",
                  width: "80"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_64, [
                      (scope.row.IsQuantity==false)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_65, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_WarningFilled)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        style: {"cursor":"pointer","margin-left":"10px"},
                        onClick: ($event: any) => (_ctx.onDelete(scope.row)),
                        title: "删除"
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Delete)
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_66)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data", "cell-style", "row-style"]),
        _createElementVNode("div", _hoisted_67, [
          (_ctx.isEdit==true)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                style: {"cursor":"pointer"},
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onAdd && _ctx.onAdd(...args)))
              }, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Plus)
                  ]),
                  _: 1
                }),
                _createTextVNode(" 添加")
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    (_ctx.logier?.CompanyType != _ctx.EnumCompanyType.Customer)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 0,
          style: {"margin-top":"5px"}
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", {
              style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isHistory = !_ctx.isHistory))
            }, [
              _hoisted_68,
              _createElementVNode("div", _hoisted_69, [
                (_ctx.isHistory==false)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowDownBold)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowUpBold)
                      ]),
                      _: 1
                    }))
              ])
            ]),
            (_ctx.isHistory==false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  (_ctx.historys.Data.Items!=null && _ctx.historys.Data.Items != undefined && _ctx.historys.Data.Items.length>0)
                    ? (_openBlock(), _createBlock(_component_el_timeline, { key: 0 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historys.Data.Items, (activity, index) => {
                            return (_openBlock(), _createBlock(_component_el_timeline_item, {
                              key: index,
                              timestamp: activity.CreatedTime,
                              "hide-timestamp": true
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_71, [
                                  _createElementVNode("div", {
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (activity.IsOpen = !activity.IsOpen)
                                  }, [
                                    _createElementVNode("div", _hoisted_73, [
                                      _createTextVNode(_toDisplayString(activity.CreatedTime) + " 由", 1),
                                      _createElementVNode("span", _hoisted_74, _toDisplayString(activity.CreatedUserName) + "（" + _toDisplayString(activity.CreatedCompanyNameZh) + "）", 1),
                                      _createTextVNode(_toDisplayString(activity.Title), 1),
                                      (activity.NewLabel!=null && activity.NewLabel!=undefined && activity.NewLabel!='')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_75, "（" + _toDisplayString(activity.NewLabel) + "）", 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (activity.IsOpen==false && activity.Child!=null && activity.Child!=undefined && activity.Child.length>0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Plus)
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                      : _createCommentVNode("", true),
                                    (activity.IsOpen==true && activity.Child!=null && activity.Child!=undefined && activity.Child.length>0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Minus)
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                      : _createCommentVNode("", true),
                                    _hoisted_78
                                  ], 8, _hoisted_72),
                                  (activity.Child!=null && activity.Child!=undefined && activity.Child.length>0 && activity.IsOpen==true)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.Child, (p, index1) => {
                                          return (_openBlock(), _createElementBlock("div", { key: index1 }, [
                                            (p.Title!=null && p.Title!=undefined && p.Title!='')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                                  (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(p.Title), 1))
                                                    : _createCommentVNode("", true),
                                                  (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                                        (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p2, index2) => {
                                                                return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                                                                  (p2.Child==null || p2.Child==undefined || p2.Child.length<=0)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                                                        (p2.State==4)
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                                                              _createTextVNode("新增了"),
                                                                              _createElementVNode("span", _hoisted_86, _toDisplayString(p2.Label), 1),
                                                                              _createTextVNode("，新值为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                            ]))
                                                                          : _createCommentVNode("", true),
                                                                        (p2.State==3)
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                                                              _createTextVNode("编辑了"),
                                                                              _createElementVNode("span", _hoisted_88, _toDisplayString(p2.Label), 1),
                                                                              _createTextVNode("，由\"" + _toDisplayString(p2.OldLabel) + "\"改为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                            ]))
                                                                          : _createCommentVNode("", true),
                                                                        (p2.State==2)
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                                                              _createTextVNode("删除了"),
                                                                              _createElementVNode("span", _hoisted_90, _toDisplayString(p2.Label), 1),
                                                                              _createTextVNode("，原值为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                            ]))
                                                                          : _createCommentVNode("", true),
                                                                        (p2.State==999)
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                                                              _createElementVNode("span", _hoisted_92, "未编辑" + _toDisplayString(p2.Label), 1),
                                                                              _createTextVNode("，原值为\"" + _toDisplayString(p2.OldLabel) + "\"", 1)
                                                                            ]))
                                                                          : _createCommentVNode("", true)
                                                                      ]))
                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                                                        (p2.Title!=null && p2.Title!=undefined && p2.Title!='')
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(p2.Title), 1))
                                                                          : (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(p2.NewLabel), 1))
                                                                      ])),
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p2.Child, (p3, index3) => {
                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                      key: index3,
                                                                      style: {"text-indent":"20px","line-height":"28px"}
                                                                    }, [
                                                                      (p3.State==4)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_96, [
                                                                            _createTextVNode("新增了"),
                                                                            _createElementVNode("span", _hoisted_97, _toDisplayString(p3.Label), 1),
                                                                            _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (p3.State==3)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_98, [
                                                                            _createTextVNode("编辑了"),
                                                                            _createElementVNode("span", _hoisted_99, _toDisplayString(p3.Label), 1),
                                                                            _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (p3.State==2)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_100, [
                                                                            _createTextVNode("删除了"),
                                                                            _createElementVNode("span", _hoisted_101, _toDisplayString(p3.Label), 1),
                                                                            _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (p3.State==999)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_102, [
                                                                            _createElementVNode("span", _hoisted_103, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                            _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true)
                                                                    ]))
                                                                  }), 128))
                                                                ]))
                                                              }), 128))
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_104, "—"))
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  _hoisted_105
                                                ]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                                  (p.Child==null || p.Child==undefined || p.Child.length<=0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                                        (p.State==4)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_108, [
                                                              _createTextVNode("新增了"),
                                                              _createElementVNode("span", _hoisted_109, _toDisplayString(p.Label), 1),
                                                              _createTextVNode("，新值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (p.State==3)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_110, [
                                                              _createTextVNode("编辑了"),
                                                              _createElementVNode("span", _hoisted_111, _toDisplayString(p.Label), 1),
                                                              _createTextVNode("，由\"" + _toDisplayString(p.OldLabel) + "\"改为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (p.State==2)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_112, [
                                                              _createTextVNode("删除了"),
                                                              _createElementVNode("span", _hoisted_113, _toDisplayString(p.Label), 1),
                                                              _createTextVNode("，原值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (p.State==999)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_114, [
                                                              _createElementVNode("span", _hoisted_115, "未编辑" + _toDisplayString(p.Label), 1),
                                                              _createTextVNode("，原值为\"" + _toDisplayString(p.OldLabel) + "\"", 1)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                                        (p.Title!=null && p.Title!=undefined && p.Title!='')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_117, _toDisplayString(p.Title), 1))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString(p.NewLabel), 1)),
                                                        _createElementVNode("div", _hoisted_119, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p3, index3) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                              style: {"clear":"both"},
                                                              key: index3
                                                            }, [
                                                              (p3.State==4)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                                                    _createTextVNode("新增了"),
                                                                    _createElementVNode("span", _hoisted_121, _toDisplayString(p3.Label), 1),
                                                                    _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (p3.State==3)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                                                    _createTextVNode("编辑了"),
                                                                    _createElementVNode("span", _hoisted_123, _toDisplayString(p3.Label), 1),
                                                                    _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (p3.State==2)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                                                    _createTextVNode("删除了"),
                                                                    _createElementVNode("span", _hoisted_125, _toDisplayString(p3.Label), 1),
                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (p3.State==999)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_126, [
                                                                    _createElementVNode("span", _hoisted_127, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          }), 128)),
                                                          _hoisted_128
                                                        ]),
                                                        _hoisted_129
                                                      ]))
                                                ]))
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["timestamp"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_130, " 暂无数据 ")),
                  (_ctx.historys.Data.Items!=null && _ctx.historys.Data.Items != undefined && _ctx.historys.Data.Items.length>0 && _ctx.historys.Data.Total>_ctx.historys.Data.Items.length)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onMoreHistyory())),
                        style: {"text-align":"center","width":"100%","line-height":"24px","height":"24px","background-color":"#00a9fc","color":"#fff","font-size":"12px","cursor":"pointer"}
                      }, [
                        _createTextVNode(" 查看更多 "),
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ArrowDownBold)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_miezz_wharf_plan, {
      ref: "WharfPlan",
      isDetail: _ctx.isDetail,
      onOnSelectPlan: _ctx.onSelectPlan,
      onOnAutoAddPlan: _ctx.onAutoAddPlan
    }, null, 8, ["isDetail", "onOnSelectPlan", "onOnAutoAddPlan"]),
    _createVNode(_component_miezz_wharf_in_stock, {
      ref: "WharfInStock",
      orderPoolId: _ctx.id,
      isDetail: _ctx.isDetail,
      onOnSelectInStock: _ctx.onSelectInStock
    }, null, 8, ["orderPoolId", "isDetail", "onOnSelectInStock"]),
    _createVNode(_component_miezz_wharf_out_stock, {
      ref: "WharfOutStock",
      orderPoolId: _ctx.id,
      isDetail: _ctx.isDetail,
      onOnSelectOutStock: _ctx.onSelectOutStock
    }, null, 8, ["orderPoolId", "isDetail", "onOnSelectOutStock"]),
    _createVNode(_component_miezz_supplier, {
      ref: "Supplier",
      isLock: _ctx.isLock,
      isDetail: _ctx.isDetail,
      onOnSelectSupplier: _ctx.onSelectSupplier
    }, null, 8, ["isLock", "isDetail", "onOnSelectSupplier"]),
    _createVNode(_component_miezz_wharf_warehousing, {
      onOnInitAnnex: _ctx.onInitAnnex,
      ref: "Warehousing",
      orderPoolId: _ctx.id,
      isDetail: _ctx.isDetail
    }, null, 8, ["onOnInitAnnex", "orderPoolId", "isDetail"]),
    _createVNode(_component_miezz_wharf_box_sticker, {
      onOnInitAnnex: _ctx.onInitAnnex,
      ref: "BoxSticker",
      orderPoolId: _ctx.id,
      isDetail: _ctx.isDetail
    }, null, 8, ["onOnInitAnnex", "orderPoolId", "isDetail"]),
    (_ctx.timeRuleForm.Data!= undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.timeRuleForm.Data.Visiable,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.timeRuleForm.Data.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.timeRuleForm.Data.Title), 1),
            _createElementVNode("div", _hoisted_132, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_miezz_form, {
              ref: "refTimeRuleForm",
              modelValue: _ctx.timeRuleForm,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.timeRuleForm) = $event)),
              fix: true
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'Time')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: item.Prop,
                      label: _ctx.timeRuleForm.Data.Label
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.timeRuleForm.Data.Time,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.timeRuleForm.Data.Time) = $event)),
                          type: "datetime",
                          style: {"width":"100% !important"},
                          placeholder: "请选择",
                          format: "YYYY/MM/DD HH:mm",
                          "default-time": _ctx.defaultTime
                        }, null, 8, ["modelValue", "default-time"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_133, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.timeBottomButtons,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.timeBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickTime
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.planInStockTimeRuleForm.Data!= undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 2,
          modelValue: _ctx.planInStockTimeRuleForm.Data.Visiable,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.planInStockTimeRuleForm.Data.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _createElementVNode("div", _hoisted_134, _toDisplayString(_ctx.planInStockTimeRuleForm.Data.Title), 1),
            _createElementVNode("div", _hoisted_135, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_miezz_form, {
              ref: "refPlanInStockTimeRuleForm",
              modelValue: _ctx.planInStockTimeRuleForm,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.planInStockTimeRuleForm) = $event)),
              fix: true,
              key: _ctx.batchFromRandom
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'Time')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: item.Prop,
                      label: _ctx.planInStockTimeRuleForm.Data.Label
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.planInStockTimeRuleForm.Data.Time,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.planInStockTimeRuleForm.Data.Time) = $event)),
                          type: "datetime",
                          style: {"width":"100% !important"},
                          placeholder: "请选择",
                          format: "YYYY/MM/DD HH:mm",
                          "default-time": _ctx.defaultTime
                        }, null, 8, ["modelValue", "default-time"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])),
            _createElementVNode("div", _hoisted_136, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.planInStockTimeBottomButtons,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.planInStockTimeBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickPlanInStockTime
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.batchForm.Data!= undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 3,
          modelValue: _ctx.batchForm.Data.Visiable,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.batchForm.Data.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _createElementVNode("div", _hoisted_137, _toDisplayString(_ctx.batchForm.Data.Title), 1),
            _createElementVNode("div", _hoisted_138, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_miezz_form, {
              ref: "refBatchForm",
              modelValue: _ctx.batchForm,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.batchForm) = $event)),
              fix: true,
              key: _ctx.batchFromRandom
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'StockTime')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: item.Prop,
                      label: _ctx.batchForm.Data.Label
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.batchForm.Data.StockTime,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.batchForm.Data.StockTime) = $event)),
                          type: "datetime",
                          style: {"width":"100% !important"},
                          placeholder: "请选择",
                          format: "YYYY/MM/DD HH:mm",
                          "default-time": _ctx.defaultTime
                        }, null, 8, ["modelValue", "default-time"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])),
            _createElementVNode("div", _hoisted_139, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.batchFormBottomButtons,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.batchFormBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickBatchForm
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.annexRuleForm.Data!= undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 4,
          modelValue: _ctx.annexRuleForm.Data.Visiable,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.annexRuleForm.Data.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_140,
            _createElementVNode("div", _hoisted_141, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_miezz_form, {
              ref: "refAnnexRuleForm",
              modelValue: _ctx.annexRuleForm,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.annexRuleForm) = $event)),
              fix: true
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'Warehouse')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "进仓通知",
                      "label-width": "100px"
                    }, {
                      label: _withCtx(() => [
                        (_ctx.annexRuleForm.Data.IsDetail!=true)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              style: _normalizeStyle((_ctx.annexRuleForm.Data.AddDeparturePortWarehouse==true)?'color:red;font-weight:900;':' ' )
                            }, " 进仓通知 ", 4))
                          : (_openBlock(), _createElementBlock("span", _hoisted_142, "进仓通知"))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { style: {"font-size":"20px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Document)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", _hoisted_143, _toDisplayString(_ctx.annexRuleForm.Data.Code), 1),
                        _createElementVNode("span", {
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onWarehousing(_ctx.annexRuleForm.Data.OrderDepartureWharfId))),
                          href: "javascript:;",
                          style: {"margin-left":"10px","cursor":"pointer","color":"#409eff"}
                        }, [
                          (_ctx.isEdit==true)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_144, "编辑"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_145, "查看"))
                        ]),
                        _createElementVNode("span", {
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onWarehousingExport(_ctx.annexRuleForm.Data))),
                          href: "javascript:;",
                          style: {"margin-left":"5px","cursor":"pointer","color":"#409eff"}
                        }, "导出")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (item.Prop == 'Box' && _ctx.annexRuleForm.Data.IsBoxSticker==true)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "箱贴",
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { style: {"font-size":"20px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Document)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", _hoisted_146, _toDisplayString(_ctx.annexRuleForm.Data.BoxStickerCode), 1),
                        _createElementVNode("span", {
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onBoxSticker(_ctx.annexRuleForm.Data.OrderDepartureWharfId))),
                          href: "javascript:;",
                          style: {"margin-left":"10px","cursor":"pointer","color":"#409eff"}
                        }, [
                          (_ctx.isEdit==true)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_147, "编辑"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_148, "查看"))
                        ]),
                        _createElementVNode("span", {
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onBoxStickerExport(_ctx.annexRuleForm.Data))),
                          href: "javascript:;",
                          style: {"margin-left":"5px","cursor":"pointer","color":"#409eff"}
                        }, "导出")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (item.Prop == 'OrderDepartureWharfId' && _ctx.annexRuleForm.Data.IsDetail!=true)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: "附件",
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.annexRuleForm.Data.Annexs,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.annexRuleForm.Data.Annexs) = $event)),
                          path: "orderDepartureWharf/annex",
                          accept: "file/*",
                          prop: "Url",
                          maxSize: 5 * 1024 * 1024
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (item.Prop == 'OrderDepartureWharfId' && _ctx.annexRuleForm.Data.IsDetail==true)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      label: "附件",
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.annexRuleForm.Data.Annexs!=null && _ctx.annexRuleForm.Data.Annexs!=undefined && _ctx.annexRuleForm.Data.Annexs.length>0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_149, [
                              _createElementVNode("td", _hoisted_150, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annexRuleForm.Data.Annexs, (p, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    style: {"line-height":"24px"},
                                    key: index
                                  }, [
                                    _hoisted_151,
                                    _createTextVNode(" 附件-" + _toDisplayString(index + 1), 1)
                                  ]))
                                }), 128))
                              ]),
                              _createElementVNode("td", _hoisted_152, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annexRuleForm.Data.Annexs, (p, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    style: {"line-height":"24px"},
                                    key: index
                                  }, [
                                    _createElementVNode("a", {
                                      style: {"color":"#409eff","text-decoration":"none"},
                                      target: "_blank",
                                      href: p.Url
                                    }, "预览", 8, _hoisted_153)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("tr", _hoisted_154, _hoisted_156))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_157, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.annexBottomButtons,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.annexBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickAnnex
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}